import state from './initialState'
import mutations from './mutations'

export default {
  state,
  mutations,
}
